(function (global) {
  'use strict';

  function parseQuantity(raw) {
    var text = String(raw == null ? '' : raw).trim();

    if (!text) {
      return { valid: false, quantity: null, reason: 'required' };
    }

    if (!/^-?\d+$/.test(text)) {
      return { valid: false, quantity: null, reason: 'integer' };
    }

    var quantity = Number(text);
    if (!Number.isSafeInteger(quantity) || quantity < 1) {
      return { valid: false, quantity: null, reason: 'range' };
    }

    return { valid: true, quantity: quantity, reason: 'ok' };
  }

function purchaseState(cents, rawQuantity, available) {
  var parsed = parseQuantity(rawQuantity);
  var unit = Number(cents);
  var total = parsed.valid ? unit * parsed.quantity : NaN;
  var totalCents = unit > 0 && Number.isSafeInteger(unit) &&
    Number.isSafeInteger(total) ? total : null;
  return {
    quantity: parsed.quantity,
    valid: parsed.valid,
    totalCents: totalCents,
    mainDisabled: !available || !parsed.valid,
    dockDisabled: !available,
    actionLabel: !available ? '選択中の仕様は在庫切れ' :
      (parsed.valid ? 'カートに入れて購入する' : '本数を修正する')
  };
}

  function submitProductForm(form, submitter) {
    if (!form) {
      return { submitted: false, method: 'missing-form' };
    }

    if (typeof form.requestSubmit === 'function') {
      if (submitter && submitter.form === form) {
        form.requestSubmit(submitter);
      } else {
        form.requestSubmit();
      }
      return { submitted: true, method: 'requestSubmit' };
    }

    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      return { submitted: false, method: 'invalid' };
    }

    if (typeof form.submit === 'function') {
      form.submit();
      return { submitted: true, method: 'submit' };
    }

    return { submitted: false, method: 'unsupported' };
  }

  global.ChaoyangProductPurchase = {
  parseQuantity: parseQuantity,
  purchaseState: purchaseState,
  submitProductForm: submitProductForm
};
})(typeof window !== 'undefined' ? window : globalThis);
